function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { withIconWrapper } from '../../components/atoms/Icon/withIconWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";

var IconPerson = function IconPerson(props, ref) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none",
    ref: ref
  }, props), ___EmotionJSX("path", {
    d: "M12 12C14.652 12 16.8 9.85203 16.8 7.20003C16.8 4.54802 14.652 2.40002 12 2.40002C9.34803 2.40002 7.20003 4.54802 7.20003 7.20003C7.20003 9.85203 9.34803 12 12 12ZM12 14.4C8.79603 14.4 2.40002 16.008 2.40002 19.2V20.4C2.40002 21.06 2.94002 21.6 3.60002 21.6H20.4C21.06 21.6 21.6 21.06 21.6 20.4V19.2C21.6 16.008 15.204 14.4 12 14.4Z"
  }));
};

export default withIconWrapper( /*#__PURE__*/forwardRef(IconPerson));
//# sourceMappingURL=IconPerson.js.map